import Styled from 'styled-components';
import {FlexColumn, Text} from '@forecast-it/design-system';

export const Form = Styled(FlexColumn)`
    width: 100%;
    gap: 16px;
`;

export const FullWidthField = Styled.div`
    width: 100%;
`;

export const ErrorText = Styled(Text)`
    color: #e0344b;
`;

export const SsoRow = Styled.div`
    display: flex;
    flex-direction: row;
    gap: 12px;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

export const SsoIconButton = Styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    padding: 0;
    border: 1px solid #e6e8ee;
    border-radius: 8px;
    background: #fff;
    cursor: pointer;

    &:hover {
        background: #f7f8fa;
    }

    /* Cap the box, not the axes: square marks (Google, OneLogin, Entra) land
       at 24px, while the wide Okta wordmark (~3:1) scales down keeping its
       aspect ratio instead of being squished into a square. */
    img {
        max-width: 36px;
        max-height: 24px;
        object-fit: contain;
    }

    svg {
        width: 24px;
        height: 24px;
    }
`;
